import React from "react";
import { useParams } from "react-router-dom";
import WeekGameSummaries from "../game/WeekGameSummaries";
import WeekLinks from "../nav/WeekLinks";

export default function LeagueWeekGames({ style, size, showWeekLinks }) {
  const { league, season } = useParams();

  size = size || "lg";
  style = style || { marginTop: "1.5rem" };
  showWeekLinks = showWeekLinks !== false;

  return (
    <>
      {showWeekLinks && (
        <WeekLinks path={`/${league}/${season}/:week/all-games`} />
      )}
      <WeekGameSummaries style={style} size={size} />
    </>
  );
}
